module.exports = "/_next/static/images/analytics-2a94680bdb5c5b62bc19f79232f26d8c.svg";